import { useCallback, useMemo } from "react";
import { useParams } from "react-router";

import { handleInvalidRequest } from "utils/sdk";

import { EFeatureLimitItemsType } from "components/FeatureLimitDialog/constants";
import { useFeatureDisabledDialog } from "components/useFeatureDisabledDialog";
import { useFeatureLimitDialog } from "components/useFeatureLimitDialog";

import { companySettingsFeatureLimitCheck } from "entities/Company/sdk";

import { ECompanySettingsFeatureType } from "./constants";

export const useCheckFeature = ({
  feature,
  callback,
}: {
  feature: ECompanySettingsFeatureType;
  callback: (...args: any) => void;
}) => {
  const params = useParams<{
    dealId?: string;
  }>();

  const dealId = useMemo(
    () =>
      feature === ECompanySettingsFeatureType.MAX_AI_SUMMARY_DOCUMENT_COUNT
        ? Number(params.dealId)
        : undefined,
    [feature, params.dealId]
  );

  const { show: showFeatureDisabledDialog } = useFeatureDisabledDialog();
  const { show: showFeatureLimitDialog } = useFeatureLimitDialog();

  const response = useCallback(
    (...args) =>
      companySettingsFeatureLimitCheck({
        featureType: feature,
        dealId: dealId,
      })
        .then(({ has_access }) => {
          if (has_access) {
            callback(...args);
          } else {
            if (feature === ECompanySettingsFeatureType.MAX_DEAL_COUNT) {
              showFeatureLimitDialog({
                items: EFeatureLimitItemsType.DEALS,
              });
            } else if (
              feature ===
              ECompanySettingsFeatureType.MAX_AI_SUMMARY_DOCUMENT_COUNT
            ) {
              showFeatureLimitDialog({
                items: EFeatureLimitItemsType.AI_SUMMARIES,
              });
            } else {
              showFeatureDisabledDialog({});
            }
          }
        })
        .catch(handleInvalidRequest),
    [
      feature,
      dealId,
      callback,
      showFeatureDisabledDialog,
      showFeatureLimitDialog,
    ]
  );

  return response;
};
